module.exports = __webpack_public_path__ + "img/mark_foot_upper_image.65c2bf09.svg";